import { find, get, map, range, isEqual } from 'lodash';

import { IAvailablePower, IVACType } from '../types/store/availablePower';
import { IBudget, IBudgetSlot } from '../types/store/budget';
import { IRouterData, IRouterSlot } from '../types/store/routerData';
import { ISlotItem, ISlotItemFull, ISlotItemPort, ISlotItemSupply, ISlotsItems } from '../types/store/slotsItems';
import { getAvailableRouterSlotsByType } from './manageRouterSlots';

// UTILS

export const removeSomeBudgetItems = (allSlotsBudget: IBudgetSlot[], slotItemID: string, qty: number) => {
  let countSlots = 0;

  return allSlotsBudget
    .reverse()
    .filter(budgetSlot => {
      if (budgetSlot.filled === slotItemID) {
        countSlots += 1;
        return qty < countSlots ? false : true;
      }
      return true;
    })
    .reverse();
};

const addSomeBudgetItems = (
  slotItem: ISlotItem,
  allSlotsRouter: IRouterSlot[],
  budgetSlots: IBudgetSlot[],
  qty: number
) => {
  const freeSlots = getAvailableRouterSlotsByType(allSlotsRouter, budgetSlots, slotItem.usedBy).reverse();
  return budgetSlots.concat(
    range(qty).map(num => ({
      name: freeSlots[num].name,
      filled: slotItem.id
    }))
  );
};

const getAvailablePower = (
  availablePowerList: IAvailablePower,
  vacType: IVACType,
  allSupplies: ISlotItemSupply[]
): number => {
  if (allSupplies.length === 0) {
    return 0;
  }
  const path = allSupplies.length > 1 ? map(allSupplies, 'model').join('.and.') : allSupplies[0].model;
  return get<any, string>(availablePowerList, `${path}.${vacType}`);
};

const getSlotBudgetItem = (slotRouterName: string, allSlotsBudget: IBudgetSlot[]) =>
  find(allSlotsBudget, ['name', slotRouterName]);

const getSlotsItemsListFromBudgetSpecs = (slotsItems: ISlotsItems, slotsSpecs: IBudgetSlot[]): ISlotItemFull[] =>
  slotsSpecs.map(slotSpec => slotsItems[slotSpec.filled]);

const isPoeEnabled = (iFrontSlotBudget: IBudgetSlot[], slotsItems: ISlotsItems): boolean =>
  getSlotsItemsListFromBudgetSpecs(slotsItems, iFrontSlotBudget).filter(slotItem =>
    isEqual(slotItem.usedBy, ['normal+plus'])
  ).length > 0;

// ACTIONS UTILS

export const updateSlotsBudget = (
  slotItem: ISlotItem,
  allSlotsRouter: IRouterSlot[],
  budgetSlots: IBudgetSlot[],
  qty: number
) => {
  const slotItemIDSlots = budgetSlots.filter(budgetSlot => budgetSlot.filled === slotItem.id);

  return slotItemIDSlots.length > qty
    ? removeSomeBudgetItems(budgetSlots, slotItem.id, qty)
    : addSomeBudgetItems(slotItem, allSlotsRouter, budgetSlots, qty - slotItemIDSlots.length);
};

export const getSlotItem = (slotRouterName: string, allSlotsBudget: IBudgetSlot[], allSlotsItems: ISlotsItems) => {
  const slotBudgetItem = getSlotBudgetItem(slotRouterName, allSlotsBudget);
  return slotBudgetItem ? allSlotsItems[slotBudgetItem.filled] : undefined;
};

export const getEnergySupplyId = (budget: IBudget) =>
  budget.slots.back.slotsSpecs.reduce((id: string, backSlot) => backSlot.filled, '');

export const getPoeWatts = (slotsItems: ISlotsItems, slotsSpecsBack: IBudgetSlot[]): number =>
  getSlotsItemsListFromBudgetSpecs(slotsItems, slotsSpecsBack).reduce(
    (acc, slotItem) => acc + (slotItem as ISlotItemSupply).poeWatts,
    0
  );

export const getAvailablePoeBudget = (
  vacType: IVACType,
  router: IRouterData,
  slotsItems: ISlotsItems,
  budget: IBudget,
  availablePowerList: IAvailablePower
): number => {
  if (!isPoeEnabled(budget.slots.front.slotsSpecs, slotsItems)) {
    return 0;
  }
  // if not powersupply
  if (budget.slots.back.slotsSpecs.length === 0) {
    return 0;
  }
  const availablePower = getAvailablePower(availablePowerList, vacType, getSlotsItemsListFromBudgetSpecs(
    slotsItems,
    budget.slots.back.slotsSpecs
  ) as ISlotItemSupply[]);
  const routerConsumption = router.powerConsumption;
  const filledSlotConsumption = getSlotsItemsListFromBudgetSpecs(slotsItems, budget.slots.front.slotsSpecs)
    .map(slotItem => (slotItem as ISlotItemPort).powerConsumption)
    .reduce((sum, itemPortPowerConsumption) => sum + itemPortPowerConsumption, 0);
  const emptySlots = getAvailableRouterSlotsByType(router.slots.front.slotsSpecs, budget.slots.front.slotsSpecs).length;
  const emptySlotsConsumption = router.emptySlotpowerConsumption * emptySlots;

  let totalBudget = availablePower - routerConsumption - filledSlotConsumption - emptySlotsConsumption;

  // =IF(TOTAL>1440,1440,TOTAL)
  return totalBudget > 1440 ? 1440 : totalBudget;
};



// WEBPACK FOOTER //
// ./src/utils/manageBudgetSlots.ts